<div class="card" data-statistics-export-grey-card="true">
    <div class="stat-widget-header">
        <h4 class="normalFontWeight">
            {{ "ALERTS_WITH_FIRST_LETTER_UPPERCASE" | translate }}
        </h4>
        <statistics-png-download-btn [widget]="this" />
    </div>

    <h2 id="alertCounter">{{ emaacAlertStats.totalAlerts }}</h2>

    <div id="chartContainer">
        <canvas id="emaacAlertsChart" width="320" height="320"></canvas>
    </div>

    <div class="legendRow">
        <div
            class="square"
            style="background-color: rgb(255, 118, 74)"
        ></div>
        <p class="legendInfo">
            {{ labels[0] + ": " + emaacAlertStats.emaAlerts }}
        </p>
    </div>

    <div class="legendRow">
        <div
            class="square"
            style="background-color: rgb(44, 63, 104)"
        ></div>
        <p class="legendInfo">
            {{ labels[1] + ": " + emaacAlertStats.finishedAlerts }}
        </p>
    </div>
</div>
